import React from 'react';
import PropTypes from 'prop-types';
import PlaceholderImage from './PlaceholderImage';

const ImageSlot = ({ image, index, altText, className }) => {
	if (!image) {
		return <PlaceholderImage index={index} className={className} />;
	}

	return (
		<img
			className={className}
			src={image.uri}
			alt={altText}
			style={{ aspectRatio: '16 / 9', objectFit: 'cover', width: '100%' }}
			loading="lazy"
		/>
	);
};

ImageSlot.propTypes = {
	image: PropTypes.shape({
		uri: PropTypes.string
	}),
	index: PropTypes.number.isRequired,
	altText: PropTypes.string,
	className: PropTypes.string
};

ImageSlot.defaultProps = {
	image: null,
	altText: ''
};

export default ImageSlot;
